export const orderArrayByProp = (arr, prop) => {
  if (arr && arr.length > 2) {
    return arr.sort((a, b) => a[prop] - b[prop])
  }

  return arr
}
